import React from "react";

const entries = [
  {
    no: "01",
    date: "Dec 2025",
    title: "On the silence of a finished hem",
    excerpt:
      "There is a moment, after the last hand-stitch is set, when the piece becomes still. We stop talking. We rotate the dress form once. We say nothing.",
  },
  {
    no: "02",
    date: "Nov 2025",
    title: "Notes from the cutting table",
    excerpt:
      "The bias is unforgiving. There is no easing it back. You cut what you mean to cut, or you have failed before the seam is set.",
  },
  {
    no: "03",
    date: "Oct 2025",
    title: "On commissioning a single skirt",
    excerpt:
      "Three private commissions are accepted each season. The fitting takes place in studio, by appointment, over a single afternoon. Tea is always served.",
  },
];

export default function Journal() {
  return (
    <main className="max-w-5xl mx-auto px-6 sm:px-12 py-20 sm:py-32" data-testid="journal-page">
      <div className="text-center fade-up">
        <p className="tracking-overline text-[11px] uppercase opacity-60">Journal</p>
        <h1 className="font-display text-5xl sm:text-7xl mt-4 leading-none">
          From the<br /><span className="italic">desk of Tamanna</span>
        </h1>
      </div>

      <div className="mt-24 space-y-20">
        {entries.map((e, i) => (
          <article key={e.no} className="grid grid-cols-12 gap-8 fade-up" style={{ animationDelay: `${i * 100}ms` }}>
            <div className="col-span-12 md:col-span-3">
              <p className="font-bodoni text-5xl opacity-30">{e.no}</p>
              <p className="text-xs uppercase tracking-[0.22em] opacity-60 mt-2">{e.date}</p>
            </div>
            <div className="col-span-12 md:col-span-9">
              <h2 className="font-display text-3xl sm:text-4xl leading-tight">{e.title}</h2>
              <p className="mt-5 opacity-80 leading-relaxed">{e.excerpt}</p>
              <button className="mt-6 btn-ghost" data-testid={`journal-read-${e.no}`}>Read entry</button>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
